









import Vue from "vue";
import {Component} from "vue-property-decorator";
@Component({
    components: {},
    props: {}
})

export default class CircularCountdown extends Vue {
    private timer = 5;

    mounted(): void
    {
        const timer = setInterval(() => {
            this.timer--;
            if (!this.timer) {
                clearInterval(timer);
                this.$emit('ended');
            }
        }, 1000);
    }
}
